module.exports = __webpack_public_path__ + "static/media/Sunny soffa 3-sits XL tyg orinocco grey miljö 2023 3.9f5d6da9.jpg";